import { SvgIcon, SvgIconProps } from "@/domains/icons/svg-icon"

export const ChevronRightIcon = ({ ...rest }: SvgIconProps) => {
  return (
    <SvgIcon {...rest}>
      <path d="M9.00005 6C9.00005 6 15 10.4189 15 12C15 13.5812 9 18 9 18" />
    </SvgIcon>
  )
}
